import classNames from 'classnames'
import _ from 'lodash'
import React, {useContext, useMemo} from 'react'
import {Link} from 'react-router-dom'
import {Mention} from './Mention'
import FeedContext from "./FeedContext";
import {checkAllowUrl} from "../../helpers/stringUtils";
import Ahref from "../Ahref";
import copyToClipboard from "copy-to-clipboard";
import {message} from "antd";

function testUrl(string) {
    let url
    try {
        url = new URL(string)
    } catch (_) {
        return false
    }
    return url.protocol === 'http:' || url.protocol === 'https:'
}

const transformDescriptionText = (str = '') => {
    const result = []
    if (!str) return result

    const regex =
        /(@[^\s]+|#url\$[^$\s]+\$[^\s]+|#\w+|https?:\/\/[^\s]+|\r\n|\n)/g

    let lastIndex = 0
    let match

    while ((match = regex.exec(str)) !== null) {
        const start = match.index
        const end = regex.lastIndex
        const token = match[0]

        if (start > lastIndex) {
            result.push({
                range: [lastIndex, start],
                type: 'text',
                text: str.slice(lastIndex, start),
            })
        }

        if (token.startsWith('@')) {
            result.push({
                range: [start, end],
                type: 'mention',
                prefix: '@',
                text: token.slice(1),
            })
        } else if (token.startsWith('#url')) {
            const [, url, text] = token.split('$')
            result.push({
                range: [start, end],
                type: 'url',
                url,
                text,
            })
        } else if (token.startsWith('#')) {
            result.push({
                range: [start, end],
                type: 'tag',
                text: token,
            })
        } else if (testUrl(token)) {
            const isValidUrl = checkAllowUrl(token)
            result.push({
                range: [start, end],
                type: 'url',
                text: token,
                ...(isValidUrl ? { url: token } : {}),
            })
        }

        lastIndex = end
    }

    if (lastIndex < str.length) {
        result.push({
            range: [lastIndex, str.length],
            type: 'text',
            text: str.slice(lastIndex),
        })
    }

    return result
}

export const mapKeywords = (children = '', keywords = [], setKeywords) => {
    if (!children || children === null) return null

    const escapeRegExp = (string) => {
        return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
    }

    const safeKeywords = Array.isArray(keywords) ? keywords : []

    const text = safeKeywords?.reduce((res, keyword) => {
        const arr = _.get(keyword, 'keyword_alt', '').split(',')
        const logRes = res
        for (var i = 0; i < arr.length; i++) {
            const regex = new RegExp(' ' + escapeRegExp(arr[i].trim() + ' '), 'i')
            res = res.replace(regex, function (match) {
                return ` @keyword:${keyword.idname}:${encodeURI(match)} `
            })
            if (res !== logRes) {
                if (setKeywords) {
                    _.pullAt(arr, i)
                    keywords = [
                        ...safeKeywords.filter((e) => e.idname !== keyword.idname),
                        {
                            ...keyword,
                            keyword_alt: arr.join(', '),
                        },
                    ]
                    setKeywords(keywords)
                }
                break
            }
        }

        return res
    }, children)

    return text
}

export const mapDocuments = (children = '', documents = [], setDocuments) => {
    if (!children || children === null) return null

    const escapeRegExp = (string) => {
        return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
    }

    const text = documents.reduce((res, document) => {
        const regex = new RegExp(
            ' ' + escapeRegExp(document.document_no.trim() + ' '),
            'i'
        )
        res = res.replace(regex, function (match) {
            return ` @docs:${document.idname}:${encodeURI(match)} `
        })

        return res
    }, children)

    return text
}

export const mapReferenceLinks = (
    children = '',
    referenceLinks = [],
    setReferenceLinks
) => {
    if (!children || children === null) return null

    const escapeRegExp = (string) => {
        return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
    }

    const text = referenceLinks.reduce((res, referenceLink) => {
        const regex = new RegExp(escapeRegExp(referenceLink.value), 'i')
        res = res.replace(regex, function (match) {
            return ` #url$${referenceLink.url}$${encodeURI(match)} `
        })

        return res
    }, children)

    return text
}

const renderEntity = (entity, mentions) => {
    if (!entity) return null

    const {type, text, prefix} = entity

    switch (type) {
        case "text":
            return text

        case "mention":
            return (
                <Mention prefix={prefix} mentions={mentions}>
                    {text}
                </Mention>
            )

        case "tag":
            return (
                <Link
                    className="hover:underline text-color-100 text-sm"
                    to={`/t/${text.substring(1)}`}
                >
                    {text}
                </Link>
            )

        case "url":
            return (
                <Ahref
                    className="italic underline text-color-100 text-sm leading-snug"
                    target="_blank"
                    rel="noopener noreferrer"
                    href={text}
                    onClick={(e) => {
                        copyToClipboard(text)
                        message.info('copied')
                    }}>
                    {decodeURI(text)}
                </Ahref>
            )

        default:
            return JSON.stringify(entity)
    }
}

const Description = ({
                         className,
                         style = {},
                         mentions = [],
                         children = "",
                         placeholder = null,
                         Wrapper = 'div'
                     }) => {
    const {handleClick} = useContext(FeedContext) // hiện tại chưa dùng
    const entities = useMemo(() => transformDescriptionText(children || ""), [children])
    const EntryWrapper = Wrapper === 'div' ? 'p' : React.Fragment

    if (_.isEmpty(children)) {
        return placeholder
    }

    return (
        <Wrapper
            style={style}
            className={classNames(
                "overflow-hidden whitespace-pre-line text-base",
                className
            )}>
            {entities.map((entity, i) => (
                <EntryWrapper key={i} {...(Wrapper === 'div' ? { className: 'm-0' } : {})}>
                    {renderEntity(entity, mentions)}
                    {i < entities.length - 1 && " "}
                </EntryWrapper>
            ))}
        </Wrapper>
    )
}

export default Description
